import { render, staticRenderFns } from "./recommendedPopup.vue?vue&type=template&id=5b9e0bf2&scoped=true&"
import script from "./recommendedPopup.vue?vue&type=script&lang=js&"
export * from "./recommendedPopup.vue?vue&type=script&lang=js&"
import style0 from "./recommendedPopup.vue?vue&type=style&index=0&id=5b9e0bf2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9e0bf2",
  null
  
)

export default component.exports